import '../social_content_view.js.coffee'
Namespace 'Monitoring.Views.SocialContents.GoogleMyBusiness'

class Monitoring.Views.SocialContents.GoogleMyBusinessContentView extends
Monitoring.Views.SocialContents.SocialContentView

  tagName: 'section'
  className: 'content google-my-business expanded'

  render: ->
    super()
    @_renderGMBRating(@_getRating())
    @

  _renderGMBRating: (starRating) ->
    reviewStarsView = new Monitoring.Views.ReviewStarsView()
    @$el.find('#review-stars').html(reviewStarsView.render().el)
    reviewStarsView.setRating(starRating) if starRating

  _getRating: ->
    return @model._getContent().getReviewSnapshot().getStarRating() if @model._getContent().isBrandContent()
    return @model._getContent().getStarRating()
